import { Button } from '@ui';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import HOCAddPatient from '../../../../components/hoc-add-patient';
import { NoPatientsSC } from './patients.styled';

type TProps = {
  onAddPatient(): void;
};

const NoPatients: React.FC<TProps> = ({ onAddPatient }) => {
  return (
    <NoPatientsSC>
      <p>
        <FormattedMessage id="patients.no_messages" />
      </p>
      <Button size="small" onClick={onAddPatient} block={false} variant="secondary">
        <FormattedMessage id="patients.start_conversation" />
      </Button>
    </NoPatientsSC>
  );
};

export default HOCAddPatient(NoPatients);
